import { fieldError } from '../fieldError';

export function checkMin(minValue) {
  return value =>
    value < minValue ? fieldError(`O valor mínimo é ${minValue}`) : null;
}
